import { getSignedUrl } from '../services/invoiceInboxService';

// Stores { url, expiresAt } keyed by filePath
const signedUrlCache = new Map();

export const getCachedSignedUrl = async (filePath, ttlSeconds = 3600) => {
  if (!filePath) return null;
  const cached = signedUrlCache?.get(filePath);
  if (cached && cached?.expiresAt > Date.now() + 60_000) {
    return cached?.url;
  }
  const url = await getSignedUrl(filePath, ttlSeconds);
  signedUrlCache?.set(filePath, { url, expiresAt: Date.now() + ttlSeconds * 1000 });
  return url;
};
